import React from 'react';
import Card from 'react-credit-cards';
import Button from 'react-bootstrap/Button';
import 'react-credit-cards/lib/styles.scss';

export const PaddleBaseUrl = 'https://api.paddle.com';
export const PaddleBearer =
  'bb7a54c973245a9dca33490ab2993d04460515cfc37c2d2dc2';
export const PaddleToken = 'live_a95d2894b4c7d1ea168b7d4e206';

export const FREE = {
  name: 'Free',
  pagesView: 100,
  pagesShared: 10,
  queries: 10,
  summary: 10,
  priceId: 'pri_01hxx02ykvh1nfxd9aw96wx684',
};

export const PRO = {
  name: 'Pro',
  pagesView: 250,
  pagesShared: 25,
  queries: 25,
  summary: 25,
  priceId: 'pri_01hxx08e2hjyx78kb2de3tfxqy',
};

export const BUSINESS = {
  name: 'Business',
  pagesView: 500,
  pagesShared: 50,
  queries: 50,
  summary: 50,
  priceId: 'pri_01hxx070xvkcfstwb7meb935z1',
};

export const CUSTOM = {
  name: 'Enterprise',
  pagesView: 'Unlimited',
  pagesShared: 'Unlimited',
  queries: 'Unlimited',
  summary: 'Unlimited',
  priceId: 'custom',
};

export const PADDLE_PLANS = [
  {
    title: FREE.name,
    price: '$0/month',
    id: FREE.priceId,
    features: [
      {
        title: 'Pages of regulations: ',
        value: FREE.pagesView,
      },
      {
        title: 'Share Results: ',
        value: FREE.pagesShared,
      },
      {
        title: 'AI Queries: ',
        value: FREE.queries,
      },
      {
        title: 'AI Summaries: ',
        value: FREE.summary,
      },
    ],
    extras: [
      'Discounted Additional AI Tokens',
      'Personalised Notification of Updates',
    ],
  },
  {
    title: PRO.name,
    price: '$9.95/month',
    id: PRO.priceId,
    isMostSelected: true,
    features: [
      {
        title: 'Pages of regulations: ',
        value: PRO.pagesView,
      },
      {
        title: 'Share Results: ',
        value: PRO.pagesShared,
      },
      {
        title: 'AI Queries: ',
        value: PRO.queries,
      },
      {
        title: 'AI Summaries: ',
        value: PRO.summary,
      },
    ],
    extras: [
      'Discounted Additional AI Tokens',
      'Personalised Notification of Updates',
    ],
  },
  {
    title: BUSINESS.name,
    price: '$19.95/month',
    id: BUSINESS.priceId,
    features: [
      {
        title: 'Pages of regulations: ',
        value: BUSINESS.pagesView,
      },
      {
        title: 'Share Results: ',
        value: BUSINESS.pagesShared,
      },
      {
        title: 'AI Queries: ',
        value: BUSINESS.queries,
      },
      {
        title: 'AI Summaries: ',
        value: BUSINESS.summary,
      },
    ],
    extras: [
      'Discounted Additional AI Tokens',
      'Personalised Notification of Updates',
      'Related Regulations Automatically Linked',
      'Translation into 100 languages',
    ],
  },
  {
    title: CUSTOM.name,
    price: 'Custom',
    id: CUSTOM.priceId,
    features: [
      {
        title: 'Pages of regulations: ',
        value: CUSTOM.pagesView,
      },
      {
        title: 'Share Results: ',
        value: CUSTOM.pagesShared,
      },
      {
        title: 'AI Queries: ',
        value: CUSTOM.queries,
      },
      {
        title: 'AI Summaries: ',
        value: CUSTOM.summary,
      },
    ],
    extras: [
      'Discounted Additional AI Tokens',
      'Personalised Notification of Updates',
      'Related Regulations Automatically Linked',
      'Translation into 100 languages',
    ],
  },
];

export const MEMBERSHIP_INFO = (user, paymentMethod, updatePayment) => {
  const { userPlan } = user;

  return [
    {
      TEXT: 'Selected Plan:',
      VALUE: userPlan.subscriptionName,
    },
    {
      TEXT: 'Start Date:',
      VALUE: userPlan.startedAt ? userPlan.startedAt : 'N/A',
    },
    userPlan.subscriptionName && userPlan.subscriptionName === 'Free'
      ? {
          TEXT: 'Auto Renews On:',
          VALUE: userPlan.endDate ? userPlan.endDate : 'N/A',
        }
      : null,
    userPlan.subscriptionName && userPlan.subscriptionName !== 'Free'
      ? {
          TEXT: 'Subscription Price:',
          VALUE: `${userPlan.currency ? userPlan.currency : null} $${
            userPlan.price
          }`,
        }
      : null,
    userPlan.subscriptionName && userPlan.subscriptionName !== 'Free'
      ? {
          TEXT: 'Next Charge on:',
          VALUE: userPlan.nextBilling,
        }
      : null,
    userPlan.subscriptionName && userPlan.subscriptionName !== 'Free'
      ? {
          TEXT: 'Billing Interval:',
          VALUE: userPlan.billingPeriod ? userPlan.billingPeriod : 'N/A',
        }
      : null,

    userPlan.userDiscount && userPlan.userDiscount.amount
      ? {
          TEXT: 'Discount Amount:',
          VALUE: userPlan.userDiscount.amount
            ? `${userPlan.userDiscount.amount}%`
            : '',
        }
      : null,
    userPlan.userDiscount && userPlan.userDiscount.amount
      ? {
          TEXT: 'Discount Created At:',
          VALUE: userPlan.userDiscount.createdAt
            ? userPlan.userDiscount.createdAt
            : '',
        }
      : null,
    userPlan.subscriptionName && userPlan.subscriptionName !== 'Free'
      ? {
          TEXT: 'Payment Method:',
          VALUE: (
            <>
              <Card
                name={
                  paymentMethod &&
                  paymentMethod.card &&
                  paymentMethod.card.cardholder_name
                    ? paymentMethod.card.cardholder_name
                    : ''
                }
                number={`************${
                  paymentMethod && paymentMethod.card.last4
                }`}
                expiry={`${
                  paymentMethod && paymentMethod.card.expiry_month
                    ? paymentMethod.card.expiry_month < 10
                      ? `0${paymentMethod.card.expiry_month}`
                      : paymentMethod.card.expiry_month
                    : ''
                }/${paymentMethod && paymentMethod.card.expiry_year}`}
                cvc='***'
                preview={true}
                issuer={paymentMethod && paymentMethod.card.type}
              />
              <Button onClick={updatePayment} className='updateBtn m-2'>
                Update Payment Method
              </Button>
            </>
          ),
        }
      : null,
  ];
};
